var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1137",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1141"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1151"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path1149"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1143",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1147",
    clipPath: "url(#clipPath1151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1153",
    transform: "translate(232.5933,52.3379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 223.522 c 12.296,0 22.264,9.968 22.264,22.264 v 86.309",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1155"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1157",
    transform: "translate(208.9111,504.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -60.689 C -72.985,0 -82.953,-9.968 -82.953,-22.264 V -169.66",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1159"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1161",
    transform: "translate(478.3789,195.0889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 287.147 c 0,12.296 -9.968,22.264 -22.264,22.264 H -235.29",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1163"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 435.2,377.006 H 169.138 v 73.718 H 435.2 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1165"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1167",
    transform: "translate(244.5381,321.7915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 2.481,4.265 7.101,7.131 12.391,7.131 h 18.57 c 7.912,0 14.326,-6.414 14.326,-14.326 0,-7.912 -6.414,-14.326 -14.326,-14.326 h -12.57",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1169"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1171",
    transform: "translate(347.4092,300.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -18.57 c -7.912,0 -14.326,6.414 -14.326,14.326 0,7.912 6.414,14.326 14.326,14.326 H 0 c 7.912,0 14.326,-6.414 14.326,-14.326 C 14.326,6.414 7.912,0 0,0 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1173"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1175",
    transform: "translate(419.3193,300.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -18.57 c -7.912,0 -14.326,6.414 -14.326,14.326 0,7.912 6.414,14.326 14.326,14.326 H 0 c 7.912,0 14.326,-6.414 14.326,-14.326 C 14.326,6.414 7.912,0 0,0 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1177"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1179",
    transform: "translate(260.9287,255.9956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 14.57 c 7.912,0 14.326,-6.414 14.326,-14.326 0,-7.912 -6.414,-14.326 -14.326,-14.326 H -4 c -7.912,0 -14.326,6.414 -14.326,14.326",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1181"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1183",
    transform: "translate(347.4092,227.3433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -18.57 c -7.912,0 -14.326,6.414 -14.326,14.326 0,7.912 6.414,14.326 14.326,14.326 H 0 c 7.912,0 14.326,-6.414 14.326,-14.326 C 14.326,6.414 7.912,0 0,0 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1185"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1187",
    transform: "translate(419.3193,227.3433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -18.57 c -7.912,0 -14.326,6.414 -14.326,14.326 0,7.912 6.414,14.326 14.326,14.326 H 0 c 7.912,0 14.326,-6.414 14.326,-14.326 C 14.326,6.414 7.912,0 0,0 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1189"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1191",
    transform: "translate(242.6025,183.0688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 0 c 0,7.912 6.414,14.326 14.326,14.326 h 18.57 c 7.913,0 14.327,-6.414 14.327,-14.326 0,-7.912 -6.414,-14.327 -14.327,-14.327 h -16.57",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1193"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1195",
    transform: "translate(347.4092,168.7422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -18.57 c -7.912,0 -14.326,6.415 -14.326,14.327 0,7.912 6.414,14.326 14.326,14.326 H 0 c 7.912,0 14.326,-6.414 14.326,-14.326 C 14.326,6.415 7.912,0 0,0 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1197"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1199",
    transform: "translate(419.3193,168.7422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -18.57 c -7.912,0 -14.326,6.415 -14.326,14.327 0,7.912 6.414,14.326 14.326,14.326 H 0 c 7.912,0 14.326,-6.414 14.326,-14.326 C 14.326,6.415 7.912,0 0,0 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1201"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1203",
    transform: "translate(262.9287,138.7944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 12.57 c 7.912,0 14.326,-6.414 14.326,-14.326 0,-7.912 -6.414,-14.327 -14.326,-14.327 H -4",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1205"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1207",
    transform: "translate(347.4092,110.1416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -18.57 c -7.912,0 -14.326,6.415 -14.326,14.327 0,7.912 6.414,14.326 14.326,14.326 H 0 c 7.912,0 14.326,-6.414 14.326,-14.326 C 14.326,6.415 7.912,0 0,0 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1209"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1211",
    transform: "translate(419.3193,110.1416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -18.57 c -7.912,0 -14.326,6.415 -14.326,14.327 0,7.912 6.414,14.326 14.326,14.326 H 0 c 7.912,0 14.326,-6.414 14.326,-14.326 C 14.326,6.415 7.912,0 0,0 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1213"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1215",
    transform: "translate(33.6206,81.8857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -41.878 C 0,-57.686 34.533,-70.855 80.291,-73.779",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1217"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1219",
    transform: "translate(148.0889,7.8667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 47.836,2.361 84.504,15.852 84.504,32.141 V 74.019",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1221"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1223",
    transform: "translate(226.6216,93.0044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 3.864,-3.469 5.972,-7.213 5.972,-11.119 0,-17.953 -44.542,-32.507 -99.487,-32.507 -54.944,0 -99.486,14.554 -99.486,32.507 0,9.681 12.95,18.373 33.498,24.328",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1225"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1227",
    transform: "translate(61.8916,160.7329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -41.878 c 0,-17.954 44.542,-32.507 99.486,-32.507 54.945,0 99.487,14.553 99.487,32.507 V 0",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1229"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1231",
    transform: "translate(226.978,185.1729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 20.773,-5.958 33.886,-14.698 33.886,-24.44 0,-17.953 -44.542,-32.507 -99.486,-32.507 -54.945,0 -99.486,14.554 -99.486,32.507 0,3.962 2.169,7.759 6.141,11.27",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1233"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1235",
    transform: "translate(33.6206,239.5806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -41.878 c 0,-17.954 44.542,-32.508 99.486,-32.508 54.945,0 99.487,14.554 99.487,32.508 v 38.554",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1237"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1239",
    transform: "translate(232.0796,236.2568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -5.095,-16.392 -47.462,-29.184 -98.973,-29.184 -54.944,0 -99.486,14.554 -99.486,32.508 0,8.343 9.618,15.951 25.429,21.707",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1241"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1243",
    transform: "translate(61.8916,302.332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -41.878 c 0,-17.954 44.542,-32.508 99.486,-32.508 54.945,0 99.487,14.554 99.487,32.508 V 0",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1245"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1247",
    transform: "translate(260.8643,302.332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-17.953 -44.542,-32.507 -99.486,-32.507 -54.945,0 -99.487,14.554 -99.487,32.507 0,17.954 44.542,32.508 99.487,32.508 C -44.542,32.508 0,17.954 0,0 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1249"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1251",
    transform: "translate(68.8145,356.4258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 25.358",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1253"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1255",
    transform: "translate(68.8145,379.6665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 25.358",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1257"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1259",
    transform: "translate(94.2222,405.4502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -0.1",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1261"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.112c1d044c5b2ee782e1d70443571c3d.svg";
export { ForwardRef as ReactComponent };